import { TEXT } from './00_assets_types'

const ES =
{
  [ TEXT.UI_MENU_USERS         ]: 'Users'
, [ TEXT.UI_MENU_CLIENTS       ]: 'Clients'
, [ TEXT.UI_MENU_WORKGROUPS    ]: 'Workgroups'
, [ TEXT.UI_MENU_JOBS          ]: 'Jobs'
, [ TEXT.UI_MENU_KEY_MASTERING  ]: 'Key Mastering'

, [ TEXT.UI_BUTTON_CREATE      ]: 'Create'
, [ TEXT.UI_BUTTON_NEW         ]: 'New'
, [ TEXT.UI_BUTTON_OK          ]: 'Ok'
, [ TEXT.UI_BUTTON_CANCEL      ]: 'Cancel'
, [ TEXT.UI_BUTTON_SAVE        ]: 'Save'
, [ TEXT.UI_BUTTON_LOGIN       ]: 'Login'
, [ TEXT.UI_BUTTON_SEND        ]: 'Send'


, [ TEXT.UI_EMAIL              ]: 'Email'
, [ TEXT.UI_ROLE               ]: 'Role'
, [ TEXT.UI_USERNAME           ]: 'User'
, [ TEXT.UI_NAME               ]: 'Name'
, [ TEXT.UI_DATE               ]: 'Date'
, [ TEXT.UI_ADDR               ]: 'Address'
, [ TEXT.UI_DESC               ]: 'Description'
, [ TEXT.UI_PRICE              ]: 'Price'
, [ TEXT.UI_NO_DATA            ]: 'No data'
, [ TEXT.UI_MACHINES           ]: 'Machines'
, [ TEXT.UI_USERS              ]: 'Users'
, [ TEXT.UI_DATE_FORMAT        ]: 'DD/MM/YYYY' // ES - date format Locale
, [ TEXT.UI_SING_OUT           ]: 'Logout'
, [ TEXT.UI_MKS_TYPE           ]: 'MKS type'
, [ TEXT.UI_KEY_APP            ]: 'Key use'
, [ TEXT.UI_CLIENT             ]: 'Client'
, [ TEXT.UI_FILE               ]: 'File'
, [ TEXT.UI_SELECT_FILE        ]: 'Select File'


, [ TEXT.UI_LOGIN_USERNAME     ]: 'Username'
, [ TEXT.UI_LOGIN_CLOUDNAME    ]: 'Cloud'
, [ TEXT.UI_LOGIN_PASSWORD     ]: 'Password'



, [ TEXT.ARE_YOU_SURE          ]: 'Are you sure?'


, [ TEXT.ERROR_NONE            ]: ''
, [ TEXT.ERROR_LOGIN_FORBIDDEN ]: 'Wrong user/cloud or password'
, [ TEXT.ERROR_LOGIN_UNAUTHORIZED ]: 'Wrong user/cloud or password'
, [ TEXT.ERROR_INTERNAL        ]: 'Internal Server Error'
, [ TEXT.ERROR_FORBIDDEN       ]: 'Access Denied'
, [ TEXT.ERROR_UNKNOWN         ]: 'There was an error, and that is all we know'

, [ TEXT.PAGE_NOT_FOUND        ]: 'Page not found'

, [ TEXT.WORKGROUPS_NEW_TITLE  ]: 'New Workgroup'
, [ TEXT.WORKGROUPS_EDIT_TITLE ]: 'Edit Workgroup'
, [ TEXT.WORKGROUPS_NAME       ]: 'Name'


, [ TEXT.USERS_NEW_TITLE       ]: 'New User'
, [ TEXT.USERS_EDIT_TITLE      ]: 'Edit User'


, [ TEXT.MACHINE_TYPE          ]: 'Machine Type'
, [ TEXT.MACHINE_NUM_JOBS      ]: '# Jobs'
, [ TEXT.MACHINE_NAME          ]: 'Machine'


, [ TEXT.CLIENT_NEW_TITLE      ]: 'New Client'
, [ TEXT.CLIENT_EDIT_TITLE     ]: 'Edit Client'
, [ TEXT.CLIENT_ADDRESS        ]: 'Address'
, [ TEXT.CLIENT_CONTACT        ]: 'Contact'
, [ TEXT.CLIENT_CONTACT_EMAIL  ]: 'Email'
, [ TEXT.CLIENT_CONTACT_PHONE  ]: 'Phone'
, [ TEXT.CLIENT_CONTACT_FAX    ]: 'Fax/Phone'
, [ TEXT.CLIENT_SURNAMES       ]: 'Surname'
, [ TEXT.CLIENT_BIRTHDAY       ]: 'Birthday'
, [ TEXT.CLIENT_NOTES          ]: 'Notes'
, [ TEXT.CLIENTS_FILTER_BY_NAME ]: 'Filter Name'
, [ TEXT.CLIENTS_FILTER_BY_ADDR ]: 'Filter Address'
, [ TEXT.CLIENTS_FILTER_BY_CONTACT ]: 'Filter Contact'
, [ TEXT.CLIENT_ADDR_STREET1   ]: 'Adress'
, [ TEXT.CLIENT_ADDR_STREET2   ]: ''
, [ TEXT.CLIENT_ADDR_CITY      ]: 'City'
, [ TEXT.CLIENT_ADDR_PROVINCE  ]: 'State'
, [ TEXT.CLIENT_ADDR_ZIP_CODE  ]: 'Zip Code'
, [ TEXT.CLIENT_ADDR_COUNTRY   ]: 'Country'


, [ TEXT.MACHINES_NEW          ]: 'New Machine'
, [ TEXT.MACHINE_SERIAL_NO     ]: 'Serial Number'

, [ TEXT.JOB_EDIT_TITLE        ]: 'Edit Job'
, [ TEXT.JOB_NEW_TITLE         ]: 'New Job'
, [ TEXT.JOB_KEY_TYPE          ]: 'Model'
, [ TEXT.JOB_NUM_KEYS          ]: 'Amount'
, [ TEXT.JOB_MACHINE           ]: 'Machine'
, [ TEXT.JOB_STATUS            ]: 'Status'
, [ TEXT.JOB_DATE              ]: 'Date'
, [ TEXT.JOB_QUANTITY          ]: 'New Amount'
, [ TEXT.JOB_FILTER_BY_STATUS  ]: 'Filter Status'
, [ TEXT.JOB_FILTER_BY_CLIENT  ]: 'Filter Clients'
, [ TEXT.JOB_FILTER_BY_MACHINE_NAME ]: 'Filter Machine'
, [ TEXT.JOB_FILTER_BY_KEY_TYPE]: 'Filter Key Type'
, [ TEXT.JOB_FILTER_BY_DATE    ]: 'Filter Date'


, [ TEXT.KEY_MASTERING_LAUNCH    ]: 'Start'
, [ TEXT.KEY_MASTERING_LAUNCH_N  ]: 'Start ({num})'
, [ TEXT.KEY_MASTERING_NEW_TITLE ]: 'Upload Mastering'
, [ TEXT.KEY_MASTERING_WILL_CREATE_N_KEYS ]: '{num} keys will be created. Are you sure?'
, [ TEXT.KEY_MASTERING_KEYS_CREATED       ]: '{num} job(s) have been created'
, [ TEXT.KEY_MASTERING_NAME               ]: 'Master Key System name'

, [ TEXT.LOGIN_FORGOT_PASSWORD_QUESTION ]: 'Forgot password?'
, [ TEXT.LOGIN_FORGOT_PASSWORD_TITLE    ]: 'Sent rest instructions to'
, [ TEXT.LOGIN_SLOGAN                   ]: 'The first cloud based key duplication app'
, [ TEXT.LOGIN_QUALITY_POINTS           ]: `
<br>
<br>
<p class="login-quality-call mb-4">
  <strong>THE FUTURE OF KEY DUPLICATION</strong>
</p>
<ul class="login-sell-points">
  <li>Keep a record of any keys copied for your customers</li>
  <br>
  <li>Store information without risk of loss and access it from anywhere</li>
  <br>
  <li>Automatic updates</li>
</ul>
`

, [ TEXT.LEGAL_TOS_TEXT              ]: 'Legal notice'
, [ TEXT.LEGAL_PRIVACY_TEXT          ]: 'Privacy policy'
, [ TEXT.LEGAL_MODEL_TEXT            ]: 'Agreement model'
, [ TEXT.LEGAL_TOS_LINK              ]: '/legal/en/legal_notice_en.pdf'
, [ TEXT.LEGAL_PRIVACY_LINK          ]: '/legal/en/privacy_policy_en.pdf'
, [ TEXT.LEGAL_MODEL_LINK            ]: '/legal/en/model_en.docx'

, [ TEXT.KEY_MODEL                   ]: 'Model'
, [ TEXT.KEY_SERIES                  ]: 'Series'
, [ TEXT.KEY_CODE                    ]: 'Code'
, [ TEXT.KEY_DATA_SHEET              ]: 'Datasheet'
, [ TEXT.KEY_BITING                  ]: 'Biting'
, [ TEXT.KEY_APPLICATION             ]: 'Application'

, [ TEXT.ENUM_JOB_STATE_PENDING      ]: 'PENDING'
, [ TEXT.ENUM_JOB_STATE_CANCELLED    ]: 'CANCELLED'
, [ TEXT.ENUM_JOB_STATE_COMPLETE     ]: 'COMPLETE'
, [ TEXT.ENUM_JOB_STATE_PROCESSING   ]: 'PROCESSING'

, [ TEXT.ENUM_USER_ROLE_ADMIN        ]: 'ADMIN'
, [ TEXT.ENUM_USER_ROLE_MANAGER      ]: 'MANAGER'
, [ TEXT.ENUM_USER_ROLE_USER         ]: 'USER'

, [ TEXT.ENUM_KEY_APP_CAR            ]: 'CAR'
, [ TEXT.ENUM_KEY_APP_HOME           ]: 'HOME'
, [ TEXT.ENUM_KEY_APP_SECURITY       ]: 'SECURITY'
, [ TEXT.ENUM_KEY_APP_LOCK           ]: 'PADLOCK'
, [ TEXT.ENUM_KEY_APP_UNSPECIFIED    ]: 'UNSPECIFIED'

, [ TEXT.FORM_HAS_ERRORS             ]: 'Please, fill-in mandatory fields in red'
}

export default ES ;
